'use client';

import { c as _c } from "react/compiler-runtime";
import { Separator } from '@achra/ui/separator';
import { FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { SearchInput } from '@/modules/shared/components/form/search-input';
import { NetworkSelect } from './network-select';
import { NetworkSelectDrawer } from './network-select-drawer';
import { StatusSelect } from './status-select';
import { StatusSelectDrawer } from './status-select-drawer';
import { useWorkstreamFilters } from './use-workstream-filters';
interface WorkstreamFiltersProps {
  showNetworkFilter?: boolean;
}
function WorkstreamFilters(t0) {
  const $ = _c(31);
  const {
    showNetworkFilter: t1
  } = t0;
  const showNetworkFilter = t1 === undefined ? true : t1;
  const {
    search,
    statuses,
    networks,
    setSearch,
    setStatuses,
    setNetworks,
    onReset
  } = useWorkstreamFilters();
  let t2;
  if ($[0] !== setSearch) {
    t2 = value => void setSearch(value);
    $[0] = setSearch;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== search || $[3] !== t2) {
    t3 = <SearchInput value={search} onChange={t2} />;
    $[2] = search;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== setStatuses || $[6] !== statuses) {
    t4 = <StatusSelect statuses={statuses} setStatuses={setStatuses} className="w-1/2 md:w-full md:max-w-54 md:min-w-54 lg:max-w-64 lg:min-w-64 xl:max-w-75 xl:min-w-75" />;
    $[5] = setStatuses;
    $[6] = statuses;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== networks || $[9] !== setNetworks || $[10] !== showNetworkFilter) {
    t5 = showNetworkFilter && <NetworkSelect networks={networks} setNetworks={setNetworks} className="w-1/2 md:w-full md:max-w-46 md:min-w-46 xl:max-w-75 xl:min-w-75" />;
    $[8] = networks;
    $[9] = setNetworks;
    $[10] = showNetworkFilter;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="hidden items-center gap-4 sm:flex lg:gap-6">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator orientation="vertical" className="h-7!" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== networks || $[17] !== setNetworks || $[18] !== showNetworkFilter) {
    t8 = showNetworkFilter && <NetworkSelectDrawer networks={networks} setNetworks={setNetworks} />;
    $[16] = networks;
    $[17] = setNetworks;
    $[18] = showNetworkFilter;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== setStatuses || $[21] !== statuses) {
    t9 = <StatusSelectDrawer statuses={statuses} setStatuses={setStatuses} />;
    $[20] = setStatuses;
    $[21] = statuses;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onReset || $[24] !== t8 || $[25] !== t9) {
    t10 = <div className="flex items-center gap-4 sm:hidden">{t7}<FilterDrawer onReset={onReset}>{t8}{t9}</FilterDrawer></div>;
    $[23] = onReset;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t3 || $[29] !== t6) {
    t11 = <div className="grid grid-cols-[1fr_auto] grid-rows-1 gap-4 sm:grid-cols-1 sm:grid-rows-2 md:flex lg:gap-6">{t3}{t6}{t10}</div>;
    $[27] = t10;
    $[28] = t3;
    $[29] = t6;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}
export { WorkstreamFilters };